<template>
  <div id="ranking-board">
    <div class="ranking-board-title">企业注册资本排行</div>
    <!-- <dv-scroll-ranking-board :config="config" /> -->
    <div class="comList">
      <div
        class="comItem"
        v-for="(item, i) in comList"
        :key="i"
        @click="handleClick($event, item)"
      >
        <div class="comName">{{ item.name }}</div>
        注册资本：{{ item.money }}
      </div>
    </div>
    <!-- 点击企业名称，弹出详情弹窗 -->
    <div class="cliclDialog2" v-if="showDialog" :style="dialogPosition">
      <div class="cliclDialog2-title">企业详情</div>
      <div class="cliclDialog2-close" @click="showDialog = false">X</div>
      <div class="comDetail">
        <div class="comDetail-item">
          <div class="comDetail-item-title">企业名称:{{ item.name }}</div>
        </div>
        <div class="comDetail-item">
          <div class="comDetail-item-title">所属行业:{{ item.type }}</div>
        </div>
        <div class="comDetail-item">
          <div class="comDetail-item-title">主导产品:{{ item.product }}</div>
        </div>
        <div class="comDetail-item">
          <div class="comDetail-item-title">
            统一社会信用代码:{{ item.tongyicode }}
          </div>
        </div>
        <div class="comDetail-item">
          <div class="comDetail-item-title">企业类别:{{ item.type2 }}</div>
        </div>
        <div class="comDetail-item">
          <div class="comDetail-item-title">经营情况:{{ item.jinyin }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RankingBoard",
  data() {
    return {
      showDialog: false,
      dialogPosition: {
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      },
      item: {},
      comList: [
        {
          name: "河南省博农实业集团有限公司",
          type: "制造业",
          product: "方便面、奶制品等",
          people: "531",
          money: "20000万元",
          jinyin: "2025年1-8月 纳税404万元",
          tongyicode: "914108221737644472",
          type2: "其他",
        },
        {
          name: "河南中方质量检测技术有限公司",
          type: "商业服务",
          product: "质检技术服务",
          people: "188",
          money: "5000万元",
          jinyin: "2025年1-8月 纳税183万元",
          tongyicode: "91410100MA40MA810W",
          type2: "质检技术服务",
        },

        {
          name: "焦作浪潮云计算有限公司",
          type: "信息技术",
          product: "云计算服务",
          people: "3",
          money: "2000万元",
          jinyin: "2025年1-8月 纳税35万元",
          tongyicode: "91410800317668033F",
          type2: "云计算服务",
        },
        {
          name: "国药器械河南豫北医疗有限公司",
          type: "药品批发",
          product: "医疗器械批发",
          people: "32",
          money: "1000万元",
          jinyin: "2025年1-8月 纳税183万元",
          tongyicode: "91410800MA44F334XT",
          type2: "医药生物",
        },
        {
          name: "焦作源生吉医疗器械有限公司",
          type: "生物医药",
          product: "医药及医疗器材批发",
          people: "5",
          money: "1000万元",
          jinyin: "2025年1-8月 纳税56万元",
          tongyicode: "91410800MA465H4176",
          type2: "医药及医疗器材批发",
        },

        {
          name: "河南华表仪控科技有限公司公司",
          type: "制造业",
          product: "热力计量表等",
          people: "19",
          money: "1000万元",
          jinyin: "2025年1-8月 纳税21万元",
          tongyicode: "914108006618967215",
          type2: "制造业",
        },

        {
          name: "焦作市乾成包装材料有限公司",
          type: "制造业",
          product: "缠绕膜",
          people: "",
          money: "500万元",
          jinyin: "2025年1-8月 纳税17万元",
          tongyicode: "91410800MA3XB2MU3C",
          type2: "塑料零件及其他塑料制品制造",
        },
        {
          name: "河南海王银河医药有限公司焦作分公司",
          type: "医药生物",
          product: "质检技术服务",
          people: "49",
          money: "300万元",
          jinyin: "2025年1-8月 纳税77万元",
          tongyicode: "91410800MA448TD89R",
          type2: "医疗器械批发",
        },

        {
          name: "焦作市众成汽车租赁有限公司",
          type: "租赁和商务服务业",
          product: "汽车租赁",
          people: "4",
          money: "100万元",
          jinyin: "2025年1-8月 纳税9万元",
          tongyicode: "914108113493706615",
          type2: "汽车租赁服务",
        },
      ],
    };
  },
  methods: {
    handleClick(event, item) {
      this.showDialog = true;
      this.item = item;

      // 获取点击元素的位置
      const rect = event.currentTarget.getBoundingClientRect();

      // 设置弹窗位置（显示在点击元素的右侧）
      this.dialogPosition = {
        position: "absolute",
        top: `${rect.top + window.scrollY}px`,
        left: `${rect.right + window.scrollX + 200}px`, // 加10px间距
        zIndex: 9999,
        width: "400px",
        backgroundColor: "rgba(6, 30, 93, 0.9)",
        border: "1px solid rgba(1, 153, 209, 0.5)",
        padding: "10px",
        borderRadius: "4px",
      };
    },
  },
};
</script>

<style lang="less">
#ranking-board {
  box-shadow: 0 0 3px blue;
  display: flex;
  flex-direction: column;
  background-color: rgba(6, 30, 93, 0.5);
  border-top: 2px solid rgba(1, 153, 209, 0.5);
  box-sizing: border-box;
  padding: 0px 5px;

  .ranking-board-title {
    font-weight: bold;
    height: 50px;
    display: flex;
    align-items: center;
    font-size: 20px;
  }

  .dv-scroll-ranking-board {
    flex: 1;
  }
}
.comItem {
  border: 1px solid rgba(1, 153, 209, 0.5);
  margin-bottom: 10px;
  padding: 0 2px;
}
</style>
<style lang="less" scoped>
.cliclDialog2 {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 400px;
  background-color: rgba(6, 30, 93, 0.5);
  border-top: 2px solid rgba(1, 153, 209, 0.5);
  box-sizing: border-box;
  padding: 0px 5px;
}
.cliclDialog2-title {
  font-weight: bold;
  height: 50px;
  display: flex;
  align-items: center;
  font-size: 20px;
}
.cliclDialog2-close {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 20px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
}
</style>
